/// <reference path="../jquery.min.js" />
/// <reference path="../globals.js" />

var commonHelpers = {

	checkElementExists: function (jQueryObj) {
		var elementExists = false;
		if (jQueryObj.length) {
			elementExists = true;
		} else {
			elementExists = false;
		}
		return elementExists;
	}
}